import {
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
} from "../http/http";

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);

export const getAuthUser = () => {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setAuthSession = (token, user) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user || {}));
};

export const updateAuthUser = (updates) => {
  const current = getAuthUser() || {};
  const next = { ...current, ...updates };
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(next));
  return next;
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
};

export const isAuthenticated = () => Boolean(getAuthToken());

export const isSubscribedUser = () => {
  const user = getAuthUser();
  return Boolean(user?.isSubscribed || Number(user?.is_subscribe) === 1);
};
